/** Landing page copy — zh, th, ja, ko, id (merged over base translations). */
export const pageZh = {
    metaTitle: 'APC Plus — 数字货币，融入日常生活',
    metaDescription:
        '使用 Digital Dollars 发送 Red Packet、购买礼品卡和 eSIM、预订旅行、赚取返现，并在 APC Plus 用一个日常余额统一管理。',
    tickerLabel: '近期动态（演示）',
    openMenu: '打开菜单',
    getStarted: '立即开始',
    navPackets: 'Red Packet',
    navShopTravel: '购物与旅行',
    navRewards: '奖励',
    navSafety: '安全',
    navMore: '更多',
    navRoadmap: '路线图',
    ddGiftCards: '礼品卡',
    ddGiftCardsDesc: '浏览热门市场的品牌',
    ddEsims: 'eSIM',
    ddEsimsDesc: '居家与出行的移动数据',
    ddTravel: '酒店与机票',
    ddTravelDesc: '用 Digital Dollars 预订行程',
    ddCashback: '返现',
    ddCashbackDesc: '符合条件的消费可获奖励',
    ddCircles: 'Circles 与群组送礼',
    ddCirclesDesc: '与亲友分享美好时刻',
    ddRwaStocks: 'RWA 股票',
    ddRwaStocksDesc: '股票挂钩资产已在路线图中',
    ddSecurityReserves: '安全与储备',
    ddSecurityReservesDesc: 'Passkey、钱包安全、储备金',
    ddRoadmapDesc: 'APC Plus 的下一步计划',
    heroEyebrow: 'APC Plus · 日常 Digital Dollars 钱包',
    heroTitleLead: 'Digital Dollars',
    heroTitleLine2: '为',
    heroTypePhrase: '日常生活而生。',
    heroTypePhrases: ['日常生活。', '人人有礼。', '万事返现。'],
    heroTitleAria: 'Digital Dollars，为日常生活、人人有礼与万事返现而生。',
    heroLedeHtml:
        'APC Plus 将支持的充值转为<strong>日常可用的 Digital Dollars</strong>。购买礼品卡与 eSIM、预订旅行、发送 Red Packet、赚取返现，一个余额即可管理全部。',
    heroSvcLabel: '您可以做什么',
    svcGiftCards: '礼品卡',
    svcEsims: 'eSIM',
    svcTravel: '酒店与机票',
    createFreeAccount: '免费注册',
    howItWorks: '工作原理',
    trustPasskey: 'Passkey 登录',
    trustFees: '提现前费用清晰透明',
    trustReserved: '1 Digital Dollar = 1 USDT，全额储备',
    heroStageLabel: 'APC Plus 应用预览',
    phoneBalLabel: '可用 Digital Dollars',
    phoneBalUnit: 'Digital Dollars',
    whatEyebrow: '什么是 APC Plus？',
    whatTitle: '稳定币，',
    whatTitleAccent: '每天都好用。',
    whatLead:
        'USDT 等加密货币快速且全球化，却难以用于真实消费。APC Plus 将其变为可用于购物、旅行与礼赠的 Digital Dollars，体验如同日常钱包。',
    pipe1Label: '1 · 充值',
    pipe1Title: '按您的方式储存',
    pipe1Text: '使用银行卡，或从任意交易所、钱包在6个公链上发送 USDT 或 USDC。',
    pipe2Label: '2 · 持有 Digital Dollars',
    pipe2Title: '安全稳定储存',
    pipe2Text:
        '1 Digital Dollar 始终等于 1 USDT，由公开储备支持。面容登录，无需助记词，无需 gas。',
    pipe3Label: '3 · 使用',
    pipe3Title: '消费、发送、赚取',
    pipe3Text: '下方所有功能共用同一余额，符合条件的购买还可享返现。',
    launchTitle: '一个余额，多种用法。',
    launchLead: '在 APC Plus 购物、旅行、发送、赚取并管理 Digital Dollars。',
    tilePacketsDesc: '发送 Digital Dollars 并附上个性化留言。',
    tileOpen: '打开 →',
    tileShopDesc: '礼品卡、代金券、eSIM、酒店与机票。',
    tileExplore: '探索 →',
    tileCashbackTitle: '返现与奖励',
    tileCashbackDesc: '符合条件的消费与活动可获奖励。',
    tileLearn: '了解更多 →',
    tileCirclesDesc: '一起庆祝，为共同礼物凑份子。',
    tileSeePackets: '查看 Red Packet →',
    comingSoon: '即将推出',
    comingLater: '稍后推出',
    statPackets: '已打开的 Red Packet',
    statCountries: '提供 eSIM 数据的国家/地区',
    statBrands: '礼品卡与代金券品牌',
    statNetworks: 'USDT 与 USDC 充值网络',
    everydayEyebrow: '日常实用',
    everydayTitle: '从日常到出行。',
    everydayLead: '用 Digital Dollars 购买您本就需要的商品，居家或旅途中皆可。',
    lifeGiftAlt: '朋友在咖啡馆分享数字礼物',
    lifeGiftEyebrow: '礼赠与日常购物',
    lifeGiftTitle: '礼品卡与代金券',
    lifeGiftCta: '探索品牌 →',
    lifeEsimAlt: '男性旅客在机场激活移动数据',
    lifeEsimEyebrow: '保持连接',
    lifeEsimTitle: '居家与出行的 eSIM',
    lifeEsimCta: '浏览 eSIM →',
    lifeTravelAlt: '旅客在手机上查看酒店预订',
    lifeTravelEyebrow: '规划下一段旅程',
    lifeTravelTitle: '酒店与机票',
    lifeTravelCta: '探索旅行 →',
    marketEyebrow: '可用场景',
    marketTitle: '覆盖热门市场的品牌。',
    marketLead: '浏览亚洲、欧洲、美洲、非洲与中东的礼品卡与代金券。',
    marketGridLabel: '热门供应商目录市场，按字母排序',
    marketNote: '覆盖范围取决于已连接的供应商目录，并可能因品牌、产品、提供商与市场而异。',
    mostLoved: '最受欢迎',
    spotTitle: '一个链接。',
    spotTitleAccent: '人人可开。',
    spotLead:
        '向 Red Packet 装入 Digital Dollars，选择拼手气或均分，发到任意群聊。未领取份额将退回给您。',
    createRedPacket: '创建 Red Packet',
    seeHowItWorks: '了解如何运作',
    popularWeek: '本周热门',
    exploreAll: '查看全部 →',
    rewardsEyebrow: '返现与奖励',
    rewardsTitle: '日常消费，小小回馈。',
    rewardsLead:
        '符合条件的购买与促销可将 Digital Dollars 计入 APC Plus 余额。用于下次购物、抵扣行程，或放入 Red Packet 发送。',
    exploreOffers: '探索优惠 →',
    trustPrivyEyebrow: 'Powered by Privy',
    trustPrivyTitle: '内置钱包安全',
    trustPrivyText:
        '加密密钥分片与隔离签名保护嵌入式钱包，无需您自行管理助记词。',
    trustPrivyLink: '了解 Privy 安全 →',
    trustAccessEyebrow: '无密码访问',
    trustAccessTitle: '按您的方式登录',
    trustAccessText: '使用邮箱一次性验证码或已绑定的 passkey，简单安全地访问 APC Plus。',
    trustAccessLink: '打开 APC Plus →',
    trustControlEyebrow: '您始终掌控',
    trustControlTitle: '发送前先确认',
    trustControlText:
        '使用 passkey 确认外部钱包提现前，请核对地址、金额及适用费用。',
    trustControlLink: '查看钱包 →',
    networksTitle: '在以下网络用 USDT 或 USDC 充值',
    roadmapHeadTitle: '即将推出',
    roadmapHeadLead: '我们正在打造的功能。',
    roadmapStockTitle: 'RWA 股票购买',
    roadmapStockDesc: '探索支持的股票挂钩现实世界资产。',
    roadmapGoldTitle: 'RWA 黄金与 Earn',
    roadmapGoldDesc: '探索黄金挂钩资产与收益体验。',
    roadmapLinksTitle: '支付链接与收款请求',
    roadmapLinksDesc: '通过邮件、QR 或链接请求或发送 Digital Dollars。',
    advancedMarketsLink: '高级市场 ↓',
    advancedEyebrow: 'APC Plus 高级版',
    advancedMarketsTitle: '高级市场',
    advancedMarketsDesc: '预测市场与永续交易独立专区。',
    advancedTitle: '预测市场与永续交易',
    advancedLead: '为希望参与高级市场的用户提供独立体验，须符合资格与当地要求。',
    finalTitle: '您的 Digital Dollars，',
    finalTitleAccent: '随时做更多。',
    finalLead: '购物、旅行、发送与赚取，尽在一个日常余额。',
    storeAppleSmall: '即将登陆',
    storeGoogleSmall: '即将登陆',
    footerBlurb: '发送、购物、赚取并管理 Digital Dollars。APC One 应用家族的一员。',
    footerExplore: '探索',
    footerCashback: '返现与奖励',
    footerSafety: '安全',
    footerOpenApp: '打开网页版',
    footerBrowse: '浏览产品',
    footerWallet: '钱包',
    footerAdvanced: '高级',
    footerContact: '联系我们',
    footerLegalNote: '产品供应因市场而异。路线图内容可能变更。',
    trademark: 'APC Plus 为 APC TECHNOLOGY SDB BHD 商标。',
};

export const pageTh = {
    metaTitle: 'APC Plus — Digital Dollars สำหรับชีวิตประจำวัน',
    metaDescription:
        'ใช้ Digital Dollars ส่ง Red Packet ช้อปบัตรของขวัญและ eSIM จองทริป รับแคชแบ็ก และจัดการยอดเงินประจำวันด้วย APC Plus',
    tickerLabel: 'กิจกรรมล่าสุด (เดโม)',
    openMenu: 'เปิดเมนู',
    getStarted: 'เริ่มต้น',
    navPackets: 'Red Packet',
    navShopTravel: 'ช้อป & ท่องเที่ยว',
    navRewards: 'รางวัล',
    navSafety: 'ความปลอดภัย',
    navMore: 'เพิ่มเติม',
    navRoadmap: 'Roadmap',
    ddGiftCards: 'บัตรของขวัญ',
    ddGiftCardsDesc: 'เลือกแบรนด์จากตลาดยอดนิยม',
    ddEsims: 'eSIM',
    ddEsimsDesc: 'ดาต้ามือถือใช้ที่บ้านและตอนเดินทาง',
    ddTravel: 'โรงแรม & ตั๋วเครื่องบิน',
    ddTravelDesc: 'จองทริปด้วย Digital Dollars',
    ddCashback: 'แคชแบ็ก',
    ddCashbackDesc: 'รับสิทธิ์จากการซื้อที่เข้าเงื่อนไข',
    ddCircles: 'Circles & ของขวัญกลุ่ม',
    ddCirclesDesc: 'แชร์ช่วงเวลากับเพื่อนและครอบครัว',
    ddRwaStocks: 'RWA Stocks',
    ddRwaStocksDesc: 'สินทรัพย์ผูกหุ้นอยู่ใน roadmap',
    ddSecurityReserves: 'ความปลอดภัย & เงินสำรอง',
    ddSecurityReservesDesc: 'Passkey ความปลอดภัยกระเป๋า เงินสำรอง',
    ddRoadmapDesc: 'สิ่งที่จะมาถัดไปของ APC Plus',
    heroEyebrow: 'APC Plus · กระเป๋า Digital Dollars ประจำวัน',
    heroTitleLead: 'Digital Dollars',
    heroTitleLine2: 'สำหรับ',
    heroTypePhrase: 'ชีวิตประจำวัน',
    heroTypePhrases: ['ชีวิตประจำวัน', 'ของขวัญทุกคน', 'เงินคืนทุกอย่าง'],
    heroTitleAria: 'Digital Dollars สำหรับชีวิตประจำวัน ของขวัญทุกคน และเงินคืนทุกอย่าง',
    heroLedeHtml:
        'APC Plus เปลี่ยนเงินฝากที่รองรับเป็น <strong>Digital Dollars ใช้ได้ทุกวัน</strong> ช้อปบัตรของขวัญและ eSIM จองทริป ส่ง Red Packet รับแคชแบ็ก และจัดการทุกอย่างในยอดเดียว',
    heroSvcLabel: 'สิ่งที่คุณทำได้',
    svcGiftCards: 'บัตรของขวัญ',
    svcEsims: 'eSIM',
    svcTravel: 'โรงแรม & ตั๋วเครื่องบิน',
    createFreeAccount: 'สร้างบัญชีฟรี',
    howItWorks: 'วิธีการทำงาน',
    trustPasskey: 'เข้าสู่ระบบด้วย Passkey',
    trustFees: 'ค่าธรรมเนียมชัดเจนก่อนถอน',
    trustReserved: '1 Digital Dollar = 1 USDT สำรองเต็มจำนวน',
    heroStageLabel: 'ตัวอย่างแอป APC Plus',
    phoneBalLabel: 'Digital Dollars ที่ใช้ได้',
    phoneBalUnit: 'Digital Dollars',
    whatEyebrow: 'APC Plus คืออะไร?',
    whatTitle: 'Stablecoin',
    whatTitleAccent: 'ใช้ได้จริงทุกวัน',
    whatLead:
        'USDT เร็วและครอบคลุมโลก แต่ใช้จ่ายของจริงยาก APC Plus เปลี่ยนเป็น Digital Dollars สำหรับช้อป ท่องเที่ยว และให้ของขวัญ ใช้งานเหมือนกระเป๋าเงินทั่วไป',
    pipe1Label: '1 · เติมเงิน',
    pipe1Title: 'เติมเงินในแบบของคุณ',
    pipe1Text: 'จ่ายด้วยบัตร หรือส่ง USDT หรือ USDC จาก exchange หรือกระเป๋าใดก็ได้บนหกเครือข่าย',
    pipe2Label: '2 · ถือ Digital Dollars',
    pipe2Title: 'ยอดคงที่เดียว',
    pipe2Text:
        '1 Digital Dollar เท่ากับ 1 USDT เสมอ มีเงินสำรองที่เปิดเผย เข้าด้วยใบหน้า ไม่มี seed phrase ไม่มี gas',
    pipe3Label: '3 · ใช้งาน',
    pipe3Title: 'ใช้ ส่ง รับรางวัล',
    pipe3Text: 'ทุกฟีเจอร์ด้านล่างใช้ยอดเดียวกัน พร้อมแคชแบ็กเมื่อซื้อ',
    launchTitle: 'ยอดเดียว ใช้ได้หลายแบบ',
    launchLead: 'ช้อป ท่องเที่ยว ส่ง รับรางวัล และจัดการ Digital Dollars บน APC Plus',
    tilePacketsDesc: 'ส่ง Digital Dollars พร้อมข้อความส่วนตัว',
    tileOpen: 'เปิด →',
    tileShopDesc: 'บัตรของขวัญ voucher eSIM โรงแรม และตั๋วเครื่องบิน',
    tileExplore: 'สำรวจ →',
    tileCashbackTitle: 'แคชแบ็ก & รางวัล',
    tileCashbackDesc: 'รับสิทธิ์จากการซื้อและโปรโมชันที่เข้าเงื่อนไข',
    tileLearn: 'เรียนรู้เพิ่ม →',
    tileCirclesDesc: 'ฉลองร่วมกันและร่วมมอบของขวัญกลุ่ม',
    tileSeePackets: 'ดู Red Packet →',
    comingSoon: 'เร็วๆ นี้',
    comingLater: 'ภายหลัง',
    statPackets: 'Red Packet ที่เปิดแล้ว',
    statCountries: 'ประเทศที่มี eSIM',
    statBrands: 'แบรนด์บัตรของขวัญ & voucher',
    statNetworks: 'เครือข่ายเติม USDT และ USDC',
    everydayEyebrow: 'ใช้ในชีวิตประจำวัน',
    everydayTitle: 'จากเรื่องธรรมดาสู่ทริปพักผ่อน',
    everydayLead: 'ใช้ Digital Dollars กับสิ่งที่คุณซื้ออยู่แล้ว ทั้งที่บ้านและตอนเดินทาง',
    lifeGiftAlt: 'เพื่อนแชร์ของขวัญดิจิทัลที่คาเฟ่',
    lifeGiftEyebrow: 'ของขวัญ & ช้อปประจำวัน',
    lifeGiftTitle: 'บัตรของขวัญ & voucher',
    lifeGiftCta: 'สำรวจแบรนด์ →',
    lifeEsimAlt: 'นักเดินทางชายเปิดใช้ดาต้าที่สนามบิน',
    lifeEsimEyebrow: 'เชื่อมต่อได้เสมอ',
    lifeEsimTitle: 'eSIM ที่บ้านและตอนเดินทาง',
    lifeEsimCta: 'ดู eSIM →',
    lifeTravelAlt: 'นักเดินทางเช็กการจองโรงแรมบนมือถือ',
    lifeTravelEyebrow: 'วางแผนทริปถัดไป',
    lifeTravelTitle: 'โรงแรม & ตั๋วเครื่องบิน',
    lifeTravelCta: 'สำรวจท่องเที่ยว →',
    marketEyebrow: 'ใช้ได้ที่ไหน',
    marketTitle: 'แบรนด์ในตลาดยอดนิยม',
    marketLead: 'เลือกบัตรของขวัญและ voucher ทั่วเอเชีย ยุโรป อเมริกา แอฟริกา และตะวันออกกลาง',
    marketGridLabel: 'ตลาดแคตตาล็อกซัพพลายเออร์ยอดนิยม เรียงตามตัวอักษร',
    marketNote: 'ความครอบคลุมขึ้นกับแคตตาล็อกที่เชื่อมต่อ และอาจแตกต่างตามแบรนด์ ผลิตภัณฑ์ ผู้ให้บริการ และตลาด',
    mostLoved: 'ยอดนิยม',
    spotTitle: 'ลิงก์เดียว',
    spotTitleAccent: 'ทุกคนเปิดได้',
    spotLead:
        'ใส่ Digital Dollars ใน Red Packet เลือกแบ่งแบบสุ่มหรือเท่ากัน แล้วส่งในแชทกลุ่ม ส่วนที่ยังไม่เปิดจะคืนให้คุณ',
    createRedPacket: 'สร้าง Red Packet',
    seeHowItWorks: 'ดูวิธีทำงาน',
    popularWeek: 'ยอดนิยมสัปดาห์นี้',
    exploreAll: 'ดูทั้งหมด →',
    rewardsEyebrow: 'แคชแบ็ก & รางวัล',
    rewardsTitle: 'ได้คืนเล็กน้อยจากสิ่งที่คุณซื้ออยู่แล้ว',
    rewardsLead:
        'การซื้อและโปรโมชันที่เข้าเงื่อนไขอาจเพิ่ม Digital Dollars ในยอด APC Plus ใช้ครั้งถัดไป ใส่ทริป หรือส่งใน Red Packet',
    exploreOffers: 'ดูข้อเสนอ →',
    trustPrivyEyebrow: 'Powered by Privy',
    trustPrivyTitle: 'ความปลอดภัยกระเป๋าในตัว',
    trustPrivyText:
        'การแบ่งกุญแจเข้ารหัสและการลงนามแยกส่วนปกป้องกระเป๋าแบบฝัง โดยไม่ต้องดูแล seed phrase เอง',
    trustPrivyLink: 'เกี่ยวกับความปลอดภัย Privy →',
    trustAccessEyebrow: 'เข้าใช้แบบไม่มีรหัสผ่าน',
    trustAccessTitle: 'เข้าสู่ระบบในแบบของคุณ',
    trustAccessText: 'ใช้รหัสครั้งเดียวทางอีเมล หรือ passkey ที่เชื่อมไว้ เพื่อเข้า APC Plus อย่างง่ายและปลอดภัย',
    trustAccessLink: 'เปิด APC Plus →',
    trustControlEyebrow: 'คุณควบคุมได้',
    trustControlTitle: 'ตรวจสอบก่อนส่ง',
    trustControlText:
        'ตรวจปลายทาง จำนวน และค่าธรรมเนียมก่อนยืนยันการถอนไปกระเป๋าภายนอกด้วย passkey',
    trustControlLink: 'ดูกระเป๋า →',
    networksTitle: 'เติมด้วย USDT หรือ USDC บน',
    roadmapHeadTitle: 'เร็วๆ นี้',
    roadmapHeadLead: 'สิ่งที่เรากำลังพัฒนา',
    roadmapStockTitle: 'ซื้อหุ้น RWA',
    roadmapStockDesc: 'ค้นหาสินทรัพย์โลกจริงที่ผูกหุ้นที่รองรับ',
    roadmapGoldTitle: 'RWA ทอง & Earn',
    roadmapGoldDesc: 'สำรวจสินทรัพย์ผูกทองและประสบการณ์รับผลตอบแทน',
    roadmapLinksTitle: 'ลิงก์ชำระเงิน & คำขอ',
    roadmapLinksDesc: 'ขอหรือส่ง Digital Dollars ทางอีเมล QR หรือลิงก์',
    advancedMarketsLink: 'ตลาดขั้นสูง ↓',
    advancedEyebrow: 'APC Plus ขั้นสูง',
    advancedMarketsTitle: 'ตลาดขั้นสูง',
    advancedMarketsDesc: 'ตลาดทำนายและเทรดถาวรในพื้นที่แยก',
    advancedTitle: 'ตลาดทำนายและเทรดถาวร',
    advancedLead:
        'ประสบการณ์แยกสำหรับผู้ที่ต้องการตลาดขั้นสูง ขึ้นกับคุณสมบัติและข้อกำหนดท้องถิ่น',
    finalTitle: 'Digital Dollars ของคุณ',
    finalTitleAccent: 'พร้อมทำได้มากขึ้น',
    finalLead: 'ช้อป ท่องเที่ยว ส่ง และรับรางวัลจากยอดประจำวันเดียว',
    storeAppleSmall: 'เร็วๆ นี้บน',
    storeGoogleSmall: 'เร็วๆ นี้บน',
    footerBlurb: 'ส่ง ช้อป รับรางวัล และจัดการ Digital Dollars ส่วนหนึ่งของครอบครัวแอป APC One',
    footerExplore: 'สำรวจ',
    footerCashback: 'แคชแบ็ก & รางวัล',
    footerSafety: 'ความปลอดภัย',
    footerOpenApp: 'เปิดเว็บแอป',
    footerBrowse: 'ดูผลิตภัณฑ์',
    footerWallet: 'กระเป๋า',
    footerAdvanced: 'ขั้นสูง',
    footerContact: 'ติดต่อ',
    footerLegalNote: 'ความพร้อมของผลิตภัณฑ์แตกต่างตามตลาด รายการ roadmap อาจเปลี่ยนแปลง',
    trademark: 'APC Plus เป็นเครื่องหมายการค้าของ APC TECHNOLOGY SDB BHD',
};

export const pageJa = {
    metaTitle: 'APC Plus — 日常のための Digital Dollars',
    metaDescription:
        'Digital Dollars で Red Packet の送信、ギフトカードや eSIM の購入、旅行予約、キャッシュバック、APC Plus ひとつの残高で日常を管理。',
    tickerLabel: '最近のアクティビティ（デモ）',
    openMenu: 'メニューを開く',
    getStarted: 'はじめる',
    navPackets: 'Red Packet',
    navShopTravel: 'ショップ & トラベル',
    navRewards: 'リワード',
    navSafety: 'セキュリティ',
    navMore: 'その他',
    navRoadmap: 'ロードマップ',
    ddGiftCards: 'ギフトカード',
    ddGiftCardsDesc: '人気マーケットのブランドを探す',
    ddEsims: 'eSIM',
    ddEsimsDesc: '自宅でも旅行先でもモバイルデータ',
    ddTravel: 'ホテル & フライト',
    ddTravelDesc: 'Digital Dollars で旅行を予約',
    ddCashback: 'キャッシュバック',
    ddCashbackDesc: '対象購入で還元',
    ddCircles: 'Circles & グループギフト',
    ddCirclesDesc: '家族や友人と瞬間を共有',
    ddRwaStocks: 'RWA Stocks',
    ddRwaStocksDesc: '株式連動資産はロードマップ上',
    ddSecurityReserves: 'セキュリティ & 準備金',
    ddSecurityReservesDesc: 'Passkey、ウォレット安全、準備金',
    ddRoadmapDesc: 'APC Plus の次の展開',
    heroEyebrow: 'APC Plus · 日常の Digital Dollars ウォレット',
    heroTitleLead: 'Digital Dollars',
    heroTitleLine2: 'を',
    heroTypePhrase: '日常に。',
    heroTypePhrases: ['日常に。', 'みんなへのギフト。', 'すべてのキャッシュバック。'],
    heroTitleAria: '日常、ギフト、キャッシュバックのための Digital Dollars。',
    heroLedeHtml:
        'APC Plus は対応入金を<strong>日常使いの Digital Dollars</strong>に。ギフトカードや eSIM の購入、旅行予約、Red Packet 送信、キャッシュバックまで、ひとつの残高で管理。',
    heroSvcLabel: 'できること',
    svcGiftCards: 'ギフトカード',
    svcEsims: 'eSIM',
    svcTravel: 'ホテル & フライト',
    createFreeAccount: '無料アカウント作成',
    howItWorks: '仕組み',
    trustPasskey: 'Passkey でサインイン',
    trustFees: '出金前に手数料を明示',
    trustReserved: '1 Digital Dollar = 1 USDT、全額準備',
    heroStageLabel: 'APC Plus アプリプレビュー',
    phoneBalLabel: '利用可能な Digital Dollars',
    phoneBalUnit: 'Digital Dollars',
    whatEyebrow: 'APC Plus とは？',
    whatTitle: 'ステーブルコインを',
    whatTitleAccent: '毎日使える形に。',
    whatLead:
        'USDT などの暗号ドルは速くグローバルですが、現実の買い物には使いにくい。APC Plus は Digital Dollars に変え、ショッピング、旅行、ギフトをいつものウォレット感覚で。',
    pipe1Label: '1 · チャージ',
    pipe1Title: '好きな方法で入金',
    pipe1Text: 'カード決済、または 6 ネットワークで取引所・ウォレットから USDT / USDC を送金。',
    pipe2Label: '2 · Digital Dollars を保有',
    pipe2Title: '安定したひとつの残高',
    pipe2Text:
        '1 Digital Dollar は常に 1 USDT。公開準備金で裏付け。顔認証でサインイン。シードフレーズも gas も不要。',
    pipe3Label: '3 · 使う',
    pipe3Title: '支払う、送る、還元を受ける',
    pipe3Text: '以下の機能はすべて同じ残高で、対象購入にキャッシュバック。',
    launchTitle: 'ひとつの残高、多彩な使い方。',
    launchLead: 'APC Plus で Digital Dollars をショップ、旅行、送金、還元、管理。',
    tilePacketsDesc: 'メッセージ付きで Digital Dollars を送る。',
    tileOpen: '開く →',
    tileShopDesc: 'ギフトカード、バウチャー、eSIM、ホテル、フライト。',
    tileExplore: '探索 →',
    tileCashbackTitle: 'キャッシュバック & リワード',
    tileCashbackDesc: '対象購入とプロモーションで還元。',
    tileLearn: '詳しく →',
    tileCirclesDesc: '一緒に祝い、共同ギフトに参加。',
    tileSeePackets: 'Red Packet を見る →',
    comingSoon: '近日公開',
    comingLater: '後日提供',
    statPackets: '開封された Red Packet',
    statCountries: 'eSIM データ提供国',
    statBrands: 'ギフトカード & バウチャーブランド',
    statNetworks: 'USDT / USDC チャージネットワーク',
    everydayEyebrow: '日常のユーティリティ',
    everydayTitle: '日常から旅へ。',
    everydayLead: '自宅でも旅行中でも、いつも買うものに Digital Dollars を。',
    lifeGiftAlt: 'カフェでデジタルギフトを分かち合う友人',
    lifeGiftEyebrow: 'ギフト & 日常ショッピング',
    lifeGiftTitle: 'ギフトカード & バウチャー',
    lifeGiftCta: 'ブランドを探す →',
    lifeEsimAlt: '空港でモバイルデータを有効化する男性旅行者',
    lifeEsimEyebrow: 'つながりをキープ',
    lifeEsimTitle: '自宅・旅行向け eSIM',
    lifeEsimCta: 'eSIM を見る →',
    lifeTravelAlt: 'スマホでホテル予約を確認する旅行者',
    lifeTravelEyebrow: '次の旅を計画',
    lifeTravelTitle: 'ホテル & フライト',
    lifeTravelCta: 'トラベルを探索 →',
    marketEyebrow: '使える場所',
    marketTitle: '人気マーケットのブランド。',
    marketLead: 'アジア、欧州、南北米、アフリカ、中東のギフトカードとバウチャー。',
    marketGridLabel: '人気サプライヤーカタログマーケット（五十音・アルファベット順）',
    marketNote: '提供範囲は接続カタログにより異なり、ブランド・商品・プロバイダー・マーケットで変動します。',
    mostLoved: '人気',
    spotTitle: 'リンクひとつ。',
    spotTitleAccent: 'みんなが開ける。',
    spotLead:
        'Red Packet に Digital Dollars を入れ、ランダムまたは均等分割を選び、グループチャットへ。未請求分は返却。',
    createRedPacket: 'Red Packet を作成',
    seeHowItWorks: '仕組みを見る',
    popularWeek: '今週の人気',
    exploreAll: 'すべて見る →',
    rewardsEyebrow: 'キャッシュバック & リワード',
    rewardsTitle: 'いつもの買い物に、小さな還元を。',
    rewardsLead:
        '対象購入とプロモで Digital Dollars が APC Plus 残高に加算。次の購入、旅行、Red Packet 送信に使えます。',
    exploreOffers: 'オファーを見る →',
    trustPrivyEyebrow: 'Powered by Privy',
    trustPrivyTitle: '組み込みウォレットセキュリティ',
    trustPrivyText:
        '暗号化キーシェアと分離署名が埋め込みウォレットを保護。シードフレーズの自己管理は不要。',
    trustPrivyLink: 'Privy セキュリティについて →',
    trustAccessEyebrow: 'パスワードレスアクセス',
    trustAccessTitle: '好きな方法でサインイン',
    trustAccessText: 'メールのワンタイムコード、またはリンク済み passkey で APC Plus にシンプルかつ安全にアクセス。',
    trustAccessLink: 'APC Plus を開く →',
    trustControlEyebrow: 'コントロールはあなた',
    trustControlTitle: '送信前に確認',
    trustControlText:
        'passkey で外部ウォレット出金を確定する前に、送付先、金額、手数料を確認。',
    trustControlLink: 'ウォレットを見る →',
    networksTitle: '次のネットワークで USDT / USDC チャージ',
    roadmapHeadTitle: '近日提供',
    roadmapHeadLead: '現在開発中の機能。',
    roadmapStockTitle: 'RWA 株式購入',
    roadmapStockDesc: '対応する株式連動リアルワールド資産を探索。',
    roadmapGoldTitle: 'RWA ゴールド & Earn',
    roadmapGoldDesc: 'ゴールド連動資産と Earn 体験を探索。',
    roadmapLinksTitle: '決済リンク & リクエスト',
    roadmapLinksDesc: 'メール、QR、リンクで Digital Dollars を請求・送信。',
    advancedMarketsLink: 'アドバンスドマーケット ↓',
    advancedEyebrow: 'APC Plus アドバンスド',
    advancedMarketsTitle: 'アドバンスドマーケット',
    advancedMarketsDesc: '予測マーケットとパーペチュアル取引は専用エリアで。',
    advancedTitle: '予測マーケットとパーペチュアル取引',
    advancedLead: 'アドバンスドマーケット向けの独立体験。適格性と現地要件の対象。',
    finalTitle: 'あなたの Digital Dollars、',
    finalTitleAccent: 'もっと活躍。',
    finalLead: 'ひとつの日常残高から、ショップ、旅行、送金、還元。',
    storeAppleSmall: '近日',
    storeGoogleSmall: '近日',
    footerBlurb: 'Digital Dollars の送金、ショップ、還元、管理。APC One アプリファミリーの一員。',
    footerExplore: '探索',
    footerCashback: 'キャッシュバック & リワード',
    footerSafety: '安全 & セキュリティ',
    footerOpenApp: 'ウェブアプリを開く',
    footerBrowse: '商品を見る',
    footerWallet: 'ウォレット',
    footerAdvanced: 'アドバンスド',
    footerContact: 'お問い合わせ',
    footerLegalNote: '製品の提供はマーケットにより異なります。ロードマップは変更される場合があります。',
    trademark: 'APC Plus は APC TECHNOLOGY SDB BHD の商標です。',
};

export const pageKo = {
    metaTitle: 'APC Plus — 일상을 위한 Digital Dollars',
    metaDescription:
        'Digital Dollars로 Red Packet 보내기, 기프트카드·eSIM 쇼핑, 여행 예약, 캐시백 적립, APC Plus 하나의 잔액으로 일상을 관리하세요.',
    tickerLabel: '최근 활동(데모)',
    openMenu: '메뉴 열기',
    getStarted: '시작하기',
    navPackets: 'Red Packet',
    navShopTravel: '쇼핑 & 여행',
    navRewards: '리워드',
    navSafety: '보안',
    navMore: '더보기',
    navRoadmap: '로드맵',
    ddGiftCards: '기프트카드',
    ddGiftCardsDesc: '인기 시장의 브랜드 둘러보기',
    ddEsims: 'eSIM',
    ddEsimsDesc: '집과 여행지 모바일 데이터',
    ddTravel: '호텔 & 항공',
    ddTravelDesc: 'Digital Dollars로 여행 예약',
    ddCashback: '캐시백',
    ddCashbackDesc: '적격 구매 시 적립',
    ddCircles: 'Circles & 그룹 선물',
    ddCirclesDesc: '가족·친구와 순간 공유',
    ddRwaStocks: 'RWA Stocks',
    ddRwaStocksDesc: '주식 연동 자산은 로드맵 예정',
    ddSecurityReserves: '보안 & 준비금',
    ddSecurityReservesDesc: 'Passkey, 지갑 안전, 준비금',
    ddRoadmapDesc: 'APC Plus의 다음 단계',
    heroEyebrow: 'APC Plus · 일상 Digital Dollars 지갑',
    heroTitleLead: 'Digital Dollars',
    heroTitleLine2: '로',
    heroTypePhrase: '일상을 만듭니다.',
    heroTypePhrases: ['일상.', '모두를 위한 선물.', '모든 캐시백.'],
    heroTitleAria: '일상, 선물, 캐시백을 위한 Digital Dollars.',
    heroLedeHtml:
        'APC Plus는 지원 입금을 <strong>매일 쓰는 Digital Dollars</strong>로 바꿉니다. 기프트카드·eSIM 쇼핑, 여행 예약, Red Packet 전송, 캐시백까지 하나의 잔액으로 관리하세요.',
    heroSvcLabel: '할 수 있는 일',
    svcGiftCards: '기프트카드',
    svcEsims: 'eSIM',
    svcTravel: '호텔 & 항공',
    createFreeAccount: '무료 계정 만들기',
    howItWorks: '작동 방식',
    trustPasskey: 'Passkey 로그인',
    trustFees: '출금 전 수수료 명확히',
    trustReserved: '1 Digital Dollar = 1 USDT, 전액 준비',
    heroStageLabel: 'APC Plus 앱 미리보기',
    phoneBalLabel: '사용 가능 Digital Dollars',
    phoneBalUnit: 'Digital Dollars',
    whatEyebrow: 'APC Plus란?',
    whatTitle: '스테이블코인을',
    whatTitleAccent: '매일 쓸 수 있게.',
    whatLead:
        'USDT 같은 크립토 달러는 빠르고 글로벌하지만 실생활 소비는 어렵습니다. APC Plus는 Digital Dollars로 바꿔 쇼핑·여행·선물을 일반 지갑처럼.',
    pipe1Label: '1 · 충전',
    pipe1Title: '원하는 방식으로 입금',
    pipe1Text: '카드 결제 또는 6개 네트워크에서 거래소·지갑으로 USDT·USDC 전송.',
    pipe2Label: '2 · Digital Dollars 보유',
    pipe2Title: '하나의 안정 잔액',
    pipe2Text:
        '1 Digital Dollar는 항상 1 USDT, 공개 준비금으로 뒷받침. 얼굴로 로그인. 시드 구문·gas 없음.',
    pipe3Label: '3 · 사용',
    pipe3Title: '쓰고, 보내고, 적립',
    pipe3Text: '아래 모든 기능이 같은 잔액을 사용하며, 구매 시 캐시백.',
    launchTitle: '하나의 잔액, 다양한 활용.',
    launchLead: 'APC Plus에서 Digital Dollars 쇼핑·여행·전송·적립·관리.',
    tilePacketsDesc: '개인 메시지와 함께 Digital Dollars 전송.',
    tileOpen: '열기 →',
    tileShopDesc: '기프트카드, 바우처, eSIM, 호텔, 항공.',
    tileExplore: '탐색 →',
    tileCashbackTitle: '캐시백 & 리워드',
    tileCashbackDesc: '적격 구매·프로모션으로 적립.',
    tileLearn: '자세히 →',
    tileCirclesDesc: '함께 축하하고 공동 선물에 참여.',
    tileSeePackets: 'Red Packet 보기 →',
    comingSoon: '곧 출시',
    comingLater: '추후 제공',
    statPackets: '열린 Red Packet',
    statCountries: 'eSIM 데이터 제공 국가',
    statBrands: '기프트카드·바우처 브랜드',
    statNetworks: 'USDT·USDC 충전 네트워크',
    everydayEyebrow: '일상 유틸리티',
    everydayTitle: '일상에서 여행까지.',
    everydayLead: '집에서든 여행 중이든, 평소 사는 것에 Digital Dollars를.',
    lifeGiftAlt: '카페에서 디지털 선물을 나누는 친구들',
    lifeGiftEyebrow: '선물 & 일상 쇼핑',
    lifeGiftTitle: '기프트카드 & 바우처',
    lifeGiftCta: '브랜드 탐색 →',
    lifeEsimAlt: '공항에서 모바일 데이터를 활성화하는 남성 여행객',
    lifeEsimEyebrow: '연결 유지',
    lifeEsimTitle: '집·여행용 eSIM',
    lifeEsimCta: 'eSIM 둘러보기 →',
    lifeTravelAlt: '휴대폰으로 호텔 예약을 확인하는 여행객',
    lifeTravelEyebrow: '다음 여행 계획',
    lifeTravelTitle: '호텔 & 항공',
    lifeTravelCta: '여행 탐색 →',
    marketEyebrow: '사용 가능 지역',
    marketTitle: '인기 시장의 브랜드.',
    marketLead: '아시아, 유럽, 아메리카, 아프리카, 중동의 기프트카드·바우처.',
    marketGridLabel: '인기 공급사 카탈로그 시장, 가나다·알파벳순',
    marketNote: '범위는 연결된 공급사 카탈로그에 따르며 브랜드·상품·제공자·시장별로 달라질 수 있습니다.',
    mostLoved: '인기',
    spotTitle: '링크 하나.',
    spotTitleAccent: '모두가 엽니다.',
    spotLead:
        'Red Packet에 Digital Dollars를 채우고 랜덤 또는 균등 분할을 선택해 그룹 채팅에 공유. 미수령분은 반환.',
    createRedPacket: 'Red Packet 만들기',
    seeHowItWorks: '작동 방식 보기',
    popularWeek: '이번 주 인기',
    exploreAll: '전체 보기 →',
    rewardsEyebrow: '캐시백 & 리워드',
    rewardsTitle: '평소 구매에 작은 적립.',
    rewardsLead:
        '적격 구매·프로모션으로 Digital Dollars가 APC Plus 잔액에 추가됩니다. 다음 구매, 여행, Red Packet 전송에 사용하세요.',
    exploreOffers: '혜택 탐색 →',
    trustPrivyEyebrow: 'Powered by Privy',
    trustPrivyTitle: '내장 지갑 보안',
    trustPrivyText:
        '암호화 키 분할과 격리 서명이 임베디드 지갑을 보호합니다. 시드 구문을 직접 관리할 필요 없습니다.',
    trustPrivyLink: 'Privy 보안 정보 →',
    trustAccessEyebrow: '비밀번호 없는 접근',
    trustAccessTitle: '원하는 방식으로 로그인',
    trustAccessText: '이메일 일회용 코드 또는 연결된 passkey로 APC Plus에 간편·안전하게 접속.',
    trustAccessLink: 'APC Plus 열기 →',
    trustControlEyebrow: '통제권은 사용자에게',
    trustControlTitle: '전송 전 검토',
    trustControlText:
        'passkey로 외부 지갑 출금을 확인하기 전에 목적지, 금액, 수수료를 확인하세요.',
    trustControlLink: '지갑 보기 →',
    networksTitle: '다음 네트워크에서 USDT·USDC 충전',
    roadmapHeadTitle: '곧 제공',
    roadmapHeadLead: '지금 개발 중인 기능.',
    roadmapStockTitle: 'RWA 주식 구매',
    roadmapStockDesc: '지원 주식 연동 실물자산(RWA) 탐색.',
    roadmapGoldTitle: 'RWA Gold & Earn',
    roadmapGoldDesc: '금 연동 자산과 Earn 경험 탐색.',
    roadmapLinksTitle: '결제 링크 & 요청',
    roadmapLinksDesc: '이메일, QR, 링크로 Digital Dollars 요청·전송.',
    advancedMarketsLink: '고급 마켓 ↓',
    advancedEyebrow: 'APC Plus 고급',
    advancedMarketsTitle: '고급 마켓',
    advancedMarketsDesc: '예측 마켓과 무기한 거래 전용 영역.',
    advancedTitle: '예측 마켓 & 무기한 거래',
    advancedLead: '고급 마켓을 원하는 분을 위한 별도 경험. 자격 및 현지 요건 적용.',
    finalTitle: '당신의 Digital Dollars,',
    finalTitleAccent: '더 넓게.',
    finalLead: '하나의 일상 잔액으로 쇼핑·여행·전송·적립.',
    storeAppleSmall: '곧 출시',
    storeGoogleSmall: '곧 출시',
    footerBlurb: 'Digital Dollars 전송·쇼핑·적립·관리. APC One 앱 패밀리의 일원.',
    footerExplore: '탐색',
    footerCashback: '캐시백 & 리워드',
    footerSafety: '안전 & 보안',
    footerOpenApp: '웹 앱 열기',
    footerBrowse: '상품 둘러보기',
    footerWallet: '지갑',
    footerAdvanced: '고급',
    footerContact: '문의',
    footerLegalNote: '제품 제공은 시장별로 다릅니다. 로드맵은 변경될 수 있습니다.',
    trademark: 'APC Plus는 APC TECHNOLOGY SDB BHD의 상표입니다.',
};

export const pageId = {
    metaTitle: 'APC Plus — Digital Dollars untuk kehidupan sehari-hari',
    metaDescription:
        'Gunakan Digital Dollars untuk mengirim Red Packet, belanja kartu hadiah dan eSIM, pesan perjalanan, dapatkan cashback, dan kelola satu saldo harian dengan APC Plus.',
    tickerLabel: 'Aktivitas terbaru (demo)',
    openMenu: 'Buka menu',
    getStarted: 'Mulai',
    navPackets: 'Red Packet',
    navShopTravel: 'Belanja & perjalanan',
    navRewards: 'Hadiah',
    navSafety: 'Keamanan',
    navMore: 'Lainnya',
    navRoadmap: 'Roadmap',
    ddGiftCards: 'Kartu hadiah',
    ddGiftCardsDesc: 'Jelajahi merek di pasar populer',
    ddEsims: 'eSIM',
    ddEsimsDesc: 'Data seluler di rumah dan saat bepergian',
    ddTravel: 'Hotel & penerbangan',
    ddTravelDesc: 'Pesan perjalanan dengan Digital Dollars',
    ddCashback: 'Cashback',
    ddCashbackDesc: 'Dapatkan reward untuk pembelian yang memenuhi syarat',
    ddCircles: 'Circles & hadiah grup',
    ddCirclesDesc: 'Bagikan momen dengan teman dan keluarga',
    ddRwaStocks: 'RWA Stocks',
    ddRwaStocksDesc: 'Aset terkait saham ada di roadmap',
    ddSecurityReserves: 'Keamanan & cadangan',
    ddSecurityReservesDesc: 'Passkey, keamanan dompet, cadangan',
    ddRoadmapDesc: 'Langkah berikutnya untuk APC Plus',
    heroEyebrow: 'APC Plus · Dompet Digital Dollars sehari-hari',
    heroTitleLead: 'Digital Dollars',
    heroTitleLine2: 'untuk',
    heroTypePhrase: 'kehidupan sehari-hari.',
    heroTypePhrases: ['kehidupan sehari-hari.', 'hadiah untuk semua.', 'cashback untuk segalanya.'],
    heroTitleAria: 'Digital Dollars untuk kehidupan sehari-hari, hadiah, dan cashback.',
    heroLedeHtml:
        'APC Plus mengubah setoran yang didukung menjadi <strong>Digital Dollars untuk pemakaian harian</strong>. Belanja kartu hadiah dan eSIM, pesan perjalanan, kirim Red Packet, dapatkan cashback, dan kelola semuanya dari satu saldo.',
    heroSvcLabel: 'Yang bisa Anda lakukan',
    svcGiftCards: 'Kartu hadiah',
    svcEsims: 'eSIM',
    svcTravel: 'Hotel & penerbangan',
    createFreeAccount: 'Buat akun gratis',
    howItWorks: 'Cara kerjanya',
    trustPasskey: 'Masuk dengan Passkey',
    trustFees: 'Biaya jelas sebelum penarikan',
    trustReserved: '1 Digital Dollar = 1 USDT, cadangan penuh',
    heroStageLabel: 'Pratinjau aplikasi APC Plus',
    phoneBalLabel: 'Digital Dollars tersedia',
    phoneBalUnit: 'Digital Dollars',
    whatEyebrow: 'Apa itu APC Plus?',
    whatTitle: 'Stablecoin,',
    whatTitleAccent: 'berguna setiap hari.',
    whatLead:
        'Dolar kripto seperti USDT cepat dan global, tapi sulit dipakai untuk hal nyata. APC Plus mengubahnya menjadi Digital Dollars untuk belanja, perjalanan, dan hadiah — seperti dompet biasa.',
    pipe1Label: '1 · Isi saldo',
    pipe1Title: 'Tambah dana sesuai cara Anda',
    pipe1Text: 'Bayar dengan kartu, atau kirim USDT atau USDC dari bursa atau dompet apa pun di enam jaringan.',
    pipe2Label: '2 · Simpan Digital Dollars',
    pipe2Title: 'Satu saldo stabil',
    pipe2Text:
        '1 Digital Dollar selalu setara 1 USDT, didukung cadangan yang dipublikasikan. Masuk dengan wajah. Tanpa seed phrase, tanpa gas.',
    pipe3Label: '3 · Gunakan',
    pipe3Title: 'Belanja, kirim, dapatkan reward',
    pipe3Text: 'Semua fitur di bawah memakai saldo yang sama, dengan cashback untuk pembelian.',
    launchTitle: 'Satu saldo. Banyak cara pakai.',
    launchLead: 'Belanja, bepergian, kirim, dapatkan reward, dan kelola Digital Dollars di APC Plus.',
    tilePacketsDesc: 'Kirim Digital Dollars dengan pesan pribadi.',
    tileOpen: 'Buka →',
    tileShopDesc: 'Kartu hadiah, voucher, eSIM, hotel, dan penerbangan.',
    tileExplore: 'Jelajahi →',
    tileCashbackTitle: 'Cashback & hadiah',
    tileCashbackDesc: 'Dapatkan reward untuk pembelian dan promo yang memenuhi syarat.',
    tileLearn: 'Pelajari →',
    tileCirclesDesc: 'Rayakan bersama dan kontribusi untuk hadiah bersama.',
    tileSeePackets: 'Lihat Red Packet →',
    comingSoon: 'Segera hadir',
    comingLater: 'Nanti',
    statPackets: 'Red Packet dibuka',
    statCountries: 'Negara dengan data eSIM',
    statBrands: 'Merek kartu hadiah & voucher',
    statNetworks: 'Jaringan isi ulang USDT dan USDC',
    everydayEyebrow: 'Utilitas sehari-hari',
    everydayTitle: 'Dari rutinitas hingga liburan.',
    everydayLead: 'Gunakan Digital Dollars untuk hal yang memang Anda beli, di rumah maupun saat bepergian.',
    lifeGiftAlt: 'Teman berbagi hadiah digital di kafe',
    lifeGiftEyebrow: 'Hadiah & belanja harian',
    lifeGiftTitle: 'Kartu hadiah & voucher',
    lifeGiftCta: 'Jelajahi merek →',
    lifeEsimAlt: 'Wisatawan pria mengaktifkan data seluler di bandara',
    lifeEsimEyebrow: 'Tetap terhubung',
    lifeEsimTitle: 'eSIM untuk rumah dan perjalanan',
    lifeEsimCta: 'Jelajahi eSIM →',
    lifeTravelAlt: 'Wisatawan memeriksa pemesanan hotel di ponsel',
    lifeTravelEyebrow: 'Rencanakan perjalanan berikutnya',
    lifeTravelTitle: 'Hotel & penerbangan',
    lifeTravelCta: 'Jelajahi perjalanan →',
    marketEyebrow: 'Di mana bisa dipakai',
    marketTitle: 'Merek di pasar populer.',
    marketLead: 'Jelajahi kartu hadiah dan voucher di Asia, Eropa, Amerika, Afrika, dan Timur Tengah.',
    marketGridLabel: 'Pasar katalog pemasok populer, diurutkan alfabetis',
    marketNote:
        'Cakupan mengikuti katalog pemasok yang terhubung dan dapat bervariasi menurut merek, produk, penyedia, dan pasar.',
    mostLoved: 'Paling disukai',
    spotTitle: 'Satu tautan.',
    spotTitleAccent: 'Semua orang membuka.',
    spotLead:
        'Isi Red Packet dengan Digital Dollars, pilih bagi hasil acak atau rata, lalu bagikan di obrolan grup. Bagian yang tidak diambil kembali ke Anda.',
    createRedPacket: 'Buat Red Packet',
    seeHowItWorks: 'Lihat cara kerjanya',
    popularWeek: 'Populer minggu ini',
    exploreAll: 'Jelajahi semua →',
    rewardsEyebrow: 'Cashback & hadiah',
    rewardsTitle: 'Sedikit kembali untuk pembelian rutin.',
    rewardsLead:
        'Pembelian dan promo yang memenuhi syarat dapat menambah Digital Dollars ke saldo APC Plus. Pakai untuk belanja berikutnya, perjalanan, atau kirim dalam Red Packet.',
    exploreOffers: 'Jelajahi penawaran →',
    trustPrivyEyebrow: 'Powered by Privy',
    trustPrivyTitle: 'Keamanan dompet bawaan',
    trustPrivyText:
        'Pembagian kunci terenkripsi dan penandatanganan terisolasi melindungi dompet embedded tanpa seed phrase manual.',
    trustPrivyLink: 'Tentang keamanan Privy →',
    trustAccessEyebrow: 'Akses tanpa kata sandi',
    trustAccessTitle: 'Masuk dengan cara Anda',
    trustAccessText: 'Gunakan kode sekali via email atau passkey tertaut untuk akses APC Plus yang sederhana dan aman.',
    trustAccessLink: 'Buka APC Plus →',
    trustControlEyebrow: 'Anda yang mengontrol',
    trustControlTitle: 'Tinjau sebelum mengirim',
    trustControlText:
        'Periksa tujuan, jumlah, dan biaya yang berlaku sebelum mengonfirmasi penarikan ke dompet eksternal dengan passkey.',
    trustControlLink: 'Lihat dompet →',
    networksTitle: 'Isi ulang dengan USDT atau USDC di',
    roadmapHeadTitle: 'Segera hadir',
    roadmapHeadLead: 'Yang sedang kami bangun.',
    roadmapStockTitle: 'Pembelian Saham RWA',
    roadmapStockDesc: 'Temukan aset dunia nyata terkait saham yang didukung.',
    roadmapGoldTitle: 'RWA Gold & Earn',
    roadmapGoldDesc: 'Jelajahi aset terkait emas dan pengalaman Earn.',
    roadmapLinksTitle: 'Tautan Pembayaran & Permintaan',
    roadmapLinksDesc: 'Minta atau kirim Digital Dollars lewat email, QR, atau tautan.',
    advancedMarketsLink: 'Pasar lanjutan ↓',
    advancedEyebrow: 'APC Plus Lanjutan',
    advancedMarketsTitle: 'Pasar lanjutan',
    advancedMarketsDesc: 'Pasar prediksi dan perpetual trading di area terpisah.',
    advancedTitle: 'Pasar prediksi & perpetual trading',
    advancedLead:
        'Pengalaman terpisah untuk pasar lanjutan, tergantung kelayakan dan persyaratan lokal.',
    finalTitle: 'Digital Dollars Anda,',
    finalTitleAccent: 'siap untuk lebih.',
    finalLead: 'Belanja, bepergian, kirim, dan dapatkan reward dari satu saldo harian.',
    storeAppleSmall: 'Segera di',
    storeGoogleSmall: 'Segera di',
    footerBlurb: 'Kirim, belanja, dapatkan reward, dan kelola Digital Dollars. Bagian dari keluarga aplikasi APC One.',
    footerExplore: 'Jelajahi',
    footerCashback: 'Cashback & hadiah',
    footerSafety: 'Keamanan',
    footerOpenApp: 'Buka web app',
    footerBrowse: 'Jelajahi produk',
    footerWallet: 'Dompet',
    footerAdvanced: 'Lanjutan',
    footerContact: 'Kontak',
    footerLegalNote: 'Ketersediaan produk bervariasi menurut pasar. Item roadmap dapat berubah.',
    trademark: 'APC Plus adalah merek dagang APC TECHNOLOGY SDB BHD.',
};
